import { render, staticRenderFns } from "./WorkflowDashboard.vue?vue&type=template&id=b90dd0ae"
import script from "./WorkflowDashboard.vue?vue&type=script&lang=js"
export * from "./WorkflowDashboard.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDashboard.vue?vue&type=style&index=0&id=b90dd0ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports